<style lang="scss">
.card-title {
  font-size: 1.94rem;
  font-family: "PingFang SC", "Microsoft YaHei";
  font-weight: bold;
  color: #4b4b4b;
  margin-top: 2rem;
}
.card-subtitle {
  font-size: 1rem;
  font-family: "PingFang SC", "Microsoft YaHei";
  font-weight: 500;
  color: #e5004f;
  margin-top: -2rem;
  margin-bottom: 2rem;
}
.card-content {
  font-size: 1.18rem;
  font-family: "PingFang SC", "Microsoft YaHei";
  font-weight: 400;
  color: #7f7f7f;
  line-height: 1.94rem;
}
.card-content-tip {
  font-size: 0.8rem;
  font-family: "PingFang SC", "Microsoft YaHei";
  font-weight: 400;
  color: #7f7f7f;
  line-height: 1.94rem;
}
.card-content-title {
  font-size: 1.8rem;
  font-family: "PingFang SC", "Microsoft YaHei";
  font-weight: 400;
  color: #7f7f7f;
  line-height: 1.94rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

@media screen and (min-width: 55rem) {
  .contactcontent {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 3rem;
    .joincontact {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .joincontact-left {
        width: 50%;
        display: flex;
        flex-direction: column;
        .new-contact-1 {
          width: 100%;
          height: 45rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #a3a0a0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          .new-contact-1-top {
            width: 100%;
            height: 22rem;
            background-size: cover;
            background-image: url("/media/yintai/contact-4.png");

            // margin-left: -1rem;
          }
          .new-contact-1-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
        .new-contact-2 {
          margin-top: 4rem;
          width: 100%;
          height: 45rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #a3a0a0;
          display: flex;
          flex-direction: column;
          align-items: center;
          .new-contact-2-top {
            width: 100%;
            height: 22rem;
            background-size: cover;

            background-image: url("/media/yintai/contact-6.png");
            // margin-left: -1rem;
          }
          .new-contact-2-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
      }

    }
  }
}

@media screen and (max-width: 55rem) {
  .contactcontent {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 3rem;
    .joincontact {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .joincontact-left {
        width: 100%;
        display: flex;
        flex-direction: column;
        .new-contact-1 {
          width: 100%;
          height: 43rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #a3a0a0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          .new-contact-1-top {
            width: 100%;
            height: 22rem;
            background-size: cover;
            background-image: url("/media/yintai/contact-4.png");

            // margin-left: -1rem;
          }
          .new-contact-1-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
        .new-contact-2 {
          margin-top: 4rem;
          width: 100%;
          height: 42rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #a3a0a0;
          display: flex;
          flex-direction: column;
          align-items: center;
          .new-contact-2-top {
            width: 100%;
            height: 22rem;
            background-size: cover;

            background-image: url("/media/yintai/contact-6.png");
            // margin-left: -1rem;
          }
          .new-contact-2-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
      }
      .joincontact-right {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 5rem;
        .new-contact-3 {
          width: 100%;
          height: 89rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #a3a0a0;
          display: flex;
          flex-direction: column;
          align-items: center;
          .new-contact-3-top {
            width: 100%;
            height: 22rem;
            background-size: cover;
            background-image: url("/media/yintai/contact-5.png");

            // margin-left: -1rem;
          }
          .new-contact-3-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="contactcontent">
    <div class="joincontact">
      <div class="joincontact-left">
        <div class="new-contact-1">
          <div class="new-contact-1-top"></div>
          <div class="new-contact-1-bottom">
            <div class="card-title">商户</div>
            <div class="card-subtitle">SOCIAL RECRUITMENT</div>
            <div class="card-content">客服咨询热线</div>
            <div class="card-content">电话400-11-91111</div>
            <div class="card-content" style="margin-top: 1rem">
              企业团购热线
            </div>
            <div class="card-content">电话0571-85068180/13857103378</div>
            <div class="card-content" style="margin-top: 1rem">
              招商热线
            </div>
            <div class="card-content">电话0571-85835972</div>
            <!-- <div class="card-content" style="margin-top: 2rem">
              &nbsp;&nbsp;
              &nbsp;面对新零售的快速发展，我们秉承“以客为先，关爱员工，创新变革”的经营理念，为培养更多新零售人才。学员通过大学生训练营，轮岗学习，企业大学阶梯式培训，项目历练而追逐渐成长为银泰新零售业务骨干！
            </div> -->
          </div>
        </div>
        <div class="new-contact-2">
          <div class="new-contact-2-top"></div>
          <div class="new-contact-2-bottom">
            <div class="card-title">媒体</div>
            <div class="card-subtitle">MEDIA</div>
            <div class="card-content">欢迎媒体记者朋友采访
            </div>
            <div class="card-content">详细采访需求可微博私信“银泰百货”</div>
            <!-- <div class="card-content" style="margin-top: 1rem;margin-bottom:1rem">
              &nbsp;&nbsp;&nbsp;面对新零售的快速发展，我们秉承“以客为先，关爱员工，创新变革”的经营理念，为培养更多新零售人才。学员通过大学生训练营，轮岗学习，企业大学阶梯式培训，项目历练而追逐渐成长为银泰新零售业务骨干！
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactcontent",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
